export const GET_INVESTOR_RELATIONS = 'GET_INVESTOR_RELATIONS';
export const GET_INVESTOR_RELATIONS_FINISHED = 'GET_INVESTOR_RELATIONS_FINISHED';

export const getInvestorRelationsAction = (payload) => ({
  type: GET_INVESTOR_RELATIONS,
  payload,
});
